import {forwardRef, type ReactNode, TextareaHTMLAttributes} from "react";
import { cn } from "@/lib/cn";

interface InputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    leading?: ReactNode;
    trailing?: ReactNode;
}

export const TextArea = forwardRef<HTMLTextAreaElement, InputProps>(function TextArea(
    { leading, trailing, className, ...rest },
    ref,
) {
    return (
        <label
            className={cn(
                "group w-full flex items-center gap-2 h-50 px-3 rounded-md bg-bridge-surface/70 border border-bridge-border/70",
                "transition-colors focus-within:border-bridge-accent/60 focus-within:shadow-ring",
                className,
            )}
        >
             <textarea
                 ref={ref}
                 className="flex-1 bg-transparent outline-none text-sm text-bridge-fg placeholder:text-bridge-subtle"
                 {...rest}
             />

        </label>

    );
});